export default "__VITE_ASSET__BAmFqSeH__"